// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.comments_page .breadcrumbs {
  background-color: #284722;
}
.comments_page .swiper_description {
  text-align: center;
}
.comments_page .swiper_description p {
  display: inline-block;
  max-width: 800px;
  text-align: center;
  color: #818181;
  font-family: "Roboto-Light";
  font-size: 17px;
}
.comments_page .container_swiper .swiper {
  width: 100%;
  height: auto;
  padding-top: 50px;
  padding-bottom: 50px;
}
.comments_page .container_swiper .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 1201px) {
  .comments_page .container_swiper .swiper-slide img {
    width: 480px;
    height: 880px;
  }
}
@media screen and (max-width: 1200px) {
  .comments_page .container_swiper .swiper-slide img {
    width: 360px;
    height: 700px;
  }
}
@media screen and (max-width: 1024px) {
  .comments_page .container_swiper .swiper-slide img {
    width: 300px;
    height: 640px;
  }
}
.comments_page .container_swiper .swiper-pagination-bullet-active {
  background: rgb(145, 182, 27);
}
.comments_page .container_text_comments .review_box {
  background-color: rgb(222, 254, 200);
  padding: 40px;
  margin: 50px auto;
  text-align: center;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}
.comments_page .container_text_comments .review_box .text_comment {
  text-align: center;
  font-family: "Roboto-Light";
  font-size: 17px;
  font-weight: 300;
  line-height: 1.5rem;
  color: #818181;
}
.comments_page .container_text_comments .review_box:nth-child(odd) .name {
  color: rgb(145, 182, 27);
}
.comments_page .container_text_comments .review_box:nth-child(even) .name {
  color: rgb(40, 71, 34);
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/pages/Comments/Comments.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AARI;EACI,yBAAA;AAUR;AAPI;EACI,kBAAA;AASR;AAPQ;EACI,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,eAAA;AASZ;AAHQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AAKZ;AAFQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAIZ;AADgB;EADJ;IAEQ,YAAA;IACA,aAAA;EAIlB;AACF;AAFgB;EANJ;IAOQ,YAAA;IACA,aAAA;EAKlB;AACF;AAHgB;EAXJ;IAYQ,YAAA;IACA,aAAA;EAMlB;AACF;AADQ;EACI,6BAAA;AAGZ;AAEQ;EACI,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;AAAZ;AAEY;EACI,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAAhB;AAKY;EACI,wBAAA;AAHhB;AAQY;EACI,sBAAA;AANhB","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n\n.comments_page {\n    .breadcrumbs {\n        background-color: #284722;\n    }\n\n    .swiper_description {\n        text-align: center;\n\n        p {\n            display: inline-block;\n            max-width: 800px;\n            text-align: center;\n            color: #818181;\n            font-family: \"Roboto-Light\";\n            font-size: 17px;\n        }\n    }\n\n    .container_swiper {\n        // height: 5vh;\n        .swiper {\n            width: 100%;\n            height: auto;\n            padding-top: 50px;\n            padding-bottom: 50px;\n        }\n\n        .swiper-slide {\n            display: flex;\n            justify-content: center;\n            align-items: center;      \n\n            img {\n                @media screen and (min-width: 1201px) {\n                    width: 480px;\n                    height: 880px;\n                }\n    \n                @media screen and (max-width: 1200px) {\n                    width: 360px;\n                    height: 700px;\n                }\n\n                @media screen and (max-width: 1024px) {\n                    width: 300px;\n                    height: 640px;\n                }\n            }\n\n        }\n\n        .swiper-pagination-bullet-active {\n            background: rgb(145, 182, 27);\n        }\n    }\n\n    .container_text_comments {\n        .review_box {\n            background-color: rgb(222, 254, 200);\n            padding: 40px;\n            margin: 50px auto;\n            text-align: center;\n            box-shadow: 0 2px 3px rgb(0 0 0 / 10%);\n\n            .text_comment {\n                text-align: center;\n                font-family: \"Roboto-Light\";\n                font-size: 17px;\n                font-weight: 300;\n                line-height: 1.5rem;\n                color: #818181;\n            }\n        }\n\n        .review_box:nth-child(odd) {\n            .name {\n                color: rgb(145, 182, 27);\n            }\n        }\n\n        .review_box:nth-child(even) {\n            .name {\n                color: rgb(40, 71, 34);\n            }\n        }\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
